/**
 * 定数
 */
export default Object.freeze({
  VALUE: 1,
  PRICES: {
    hasRemoval: {
      0: 0,
      1: 6600
    },
    hasRecycling: { 
      0: 0,
      1: 0,
      2: 3300,
    },
    airconType: {
      0: 19800,
      1: 25300,
      2: 29700,
      3: 0
    },
    hasSocket: {
      0: 0,
      1: 27500
    },
    socketType: {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      0: 0
    },
    hasHole: {
      0: 0,
      1: 3300,
      2: 22000
    },
    extentionTube: {
      0: 0,
      1: 4400,
      2: 8800,
      3: 13200,
      4: 17600,
      5: 22000,
    },
    sameFloor: {
      0: 0,
      1: 24200,
      2: 49500
    },
    holeType: {
      0: 0,
      1: 11000
    },
    unitType: {
      0: 0,
      1: 0,
      2: 7700,
      3: 16500,
      4: 7700,
      5: 16500,
      6: 7700,
      7: 16500,
      8: 0,
      9: 22000,
    },
    unitFloor: {
      0: 0,
      1: 11000,
      2: 27500,
      3: 0,
      4: 11000,
      5: 27500,
    }
  },
  
  // メール送信用の文言セット
  PRICE_FOR_MAIL: {
    hasRemoval: {
      question: 'エアコンの取り外しはありますか？',
      answers: [
        {
          answer: '新規取付のみ',
          price: 0
        },
        {
          answer: '取り外しあり',
          price: 6600
        }
      ]
    },
    hasRecycling: {
      question: '回収するエアコンはありますか？',
      answers: [
        {
          answer: '回収を依頼しない',
          price: 0
        },
        {
          answer: '回収を依頼する(製造年式 2012年以降)',
          price: 0
        },
        {
          answer: '回収を依頼する(製造年式 2011年以前)',
          price: 3300
        }
      ]
    },
    airconType: {
      question: 'エアコンのタイプを選択してください',
      answers: [
        {
          answer: '6~12畳用',
          price: 19800
        },
        {
          answer: '12~20畳用',
          price: 25300
        },
        {
          answer: '20~32畳用',
          price: 29700
        },
        {
          answer: '工事費込商品を購入',
          price: 0
        }
      ]
    },
    hasSocket: {
      question: '専用コンセントが近くにありますか?',
      answers: [
        {
          answer: '専用コンセントが近くにある',
          price: 0
        },
        {
          answer: '専用コンセントが近くにない',
          price: 27500
        }
      ]
    },
    socketType: {
      question: 'コンセントの形状は?',
      answers: [
        {
          answer: '100V 15A 専用 平行型',
          price: 0
        },
        {
          answer: '100V 20A 専用 IL(アイエル)型',
          price: 0
        },
        {
          answer: '100V 15/20A 兼用 IL(アイエル)型',
          price: 0
        },
        {
          answer: '200V 15A 専用 タンデム型',
          price: 0
        },
        {
          answer: '200V 15/20A 兼用 エルバー型',
          price: 0
        },
        {
          answer: 'それ以外 / 不明',
          price: 0
        }
      ]
    },
    hasHole: {
      question: '配管ホースを通す穴が近くにありますか?',
      answers: [
        {
          answer: 'ある',
          price: 0
        },
        {
          answer: 'ない。壁材: 木造・モルタル・ALC',
          price: 3300
        },
        {
          answer: 'ない。壁材: 鉄筋コンクリート',
          price: 22000
        }
      ]
    },
    extentionTube: {
      question: '室外機までの距離は?',
      answers: [
        {
          answer: '4m以内',
          price: 0
        },
        {
          answer: '5m',
          price: 4400
        },
        {
          answer: '6m',
          price: 8800
        },
        {
          answer: '7m',
          price: 13200
        },
        {
          answer: '8m',
          price: 17600
        },
        {
          answer: '9m',
          price: 22000
        },
      ]
    },
    sameFloor: {
      question: '室内機と室外機は同じ階に設置できますか?',
      answers: [
        {
          answer: '同じ階に設置できる',
          price: 0
        },
        {
          answer: '同じ階に設置できない(1階差)',
          price: 24200
        },
        {
          answer: '同じ階に設置できない(2階差)',
          price: 49500
        }
      ]
    },
    holeType: {
      question: '配管を通す「穴」の位置は?',
      answers: [
        {
          answer: '穴が外まで同じ位置で貫通している',
          price: 0
        },
        {
          answer: '内側と屋外側で穴の位置が違う（隠蔽配管）',
          price: 11000
        }
      ]
    },
    unitType: {
      question: '室外機の設置場所は?',
      answers: [
        {
          answer: '通常配置(地面やベランダ)',
          price: 0
        },
        {
          answer: 'その他 / 不明',
          price: 0
        },
        {
          answer: '壁面置き(建物の壁面に直接配置) - 既設架台再利用',
          price: 7700
        },
        {
          answer: '壁面置き(建物の壁面に直接配置) - 架台新設交換',
          price: 16500
        },
        {
          answer: '天つり置き(ベランダなどの天井から吊るす) - 既設架台再利用',
          price: 7700
        },
        {
          answer: '天つり置き(ベランダなどの天井から吊るす) - 架台新設交換',
          price: 16500
        },
        {
          answer: '屋根置き - 既設架台再利用',
          price: 7700
        },
        {
          answer: '屋根置き - 架台新設交換',
          price: 16500
        },
        {
          answer: '二段置き - 既設架台再利用',
          price: 0
        },
        {
          answer: '二段置き - 架台新設交換',
          price: 22000
        },
      ]
    },
    unitFloor: {
      question: '室外機を設置する階は?',
      answers: [
        {
          answer: '-',
          price: 0
        },
        {
          answer: '1階部分の屋根',
          price: 11000
        },
        {
          answer: '2階部分の屋根',
          price: 27500
        },
        {
          answer: '1階の壁面',
          price: 0
        },
        {
          answer: '2階の壁面',
          price: 11000
        },
        {
          answer: '3階の壁面',
          price: 27500
        }
      ]
    }
  },
});